const connection = io.connect(`${location.protocol}//${location.hostname}:4002/`);

module.exports = {
	connection
}
